<template>
  <div>
    <BreadCrumbs />
    <JapanVisa id="f"/>
    <HoverBox />
    <ChooseTab />
    <MultinationalVisa 
      id="t"
      @set-search="setSearch"  
    />
    <NationalFlag 
      :searchKey="searchKey"
      @set-search="setSearch"
    />
  </div>
</template>

<script>
import BreadCrumbs from '@/components/home/breadCrumbs'
import JapanVisa from '@/components/home/goaboard/siderContent-01.vue'
import HoverBox from '@/components/home/goaboard/siderContent-02.vue'
import ChooseTab from '@/components/home/goaboard/siderContent-03.vue'
import MultinationalVisa from '@/components/home/goaboard/siderContent-04.vue'
import NationalFlag from '@/components/home/goaboard/siderContent-05.vue'

import { mixin } from '@/mixin/mixin.js'
export default {
  name: 'goaboard',
  components: {
    BreadCrumbs,
    JapanVisa,
    HoverBox,
    ChooseTab,
    MultinationalVisa,
    NationalFlag
  },
  mixins: [mixin],
  data () {
    return {
      searchKey: ''
    }
  },
  methods: {
    setSearch (e) {
      this.searchKey = e
    }
  }
}
</script>

<style scoped lang='less'>
body {
  overflow-x: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/home/goaboard/index.vue